<template>
    <svg
        height="24px"
        width="24px"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="none"
    >
        <g id="SVGRepo_bgCarrier" stroke-width="0" />

        <g id="SVGRepo_iconCarrier">
            <circle cx="12" cy="7" r="4" stroke="#000000" stroke-width="1" />
            <path
                d="M14.9999 14H8.99991C6.23848 14 3.76499 16.5498 5.58239 18.6289C6.81829 20.0428 8.86211 21 11.9999 21C15.1377 21 17.1815 20.0428 18.4174 18.6289C20.2348 16.5498 17.7613 14 14.9999 14Z"
                stroke="#000000"
                stroke-width="1"
            />
        </g>
    </svg>
</template>

<script lang="ts">
import { defineComponent } from "vue";
export default defineComponent({
    name: "oss-outlined-user",
});
</script>
